module.exports = __webpack_public_path__ + "img/Mask-Banner.9e8e3a14.png";